import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api, getToken, setToken, clearToken } from "@/api/client";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [auth, setAuth] = useState(null); // null = checking, object = authed, false = anon

  useEffect(() => {
    if (!getToken()) { setAuth(false); return; }
    api.get("/auth/me").then((r) => setAuth(r.data)).catch(() => { clearToken(); setAuth(false); });
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setToken(data.token);
    const me = await api.get("/auth/me");
    setAuth(me.data);
    return me.data;
  }, []);

  const logout = useCallback(() => { clearToken(); setAuth(false); window.location.assign("/login"); }, []);

  return <AuthContext.Provider value={{ auth, login, logout }}>{children}</AuthContext.Provider>;
}
